export const dashboardRoutes = {
  home: '/dashboard',
};

export const appRoutes = {
  masses: '/masses',
  mySignups: '/my-signups',
  profile: '/profile',
  playerStats: '/player-stats',
};

export const templateRoutes = {
  list: '/dashboard/templates',
  create: '/dashboard/templates/new',
  editPattern: '/dashboard/templates/:templateId/edit',
  edit: (templateId: string) => `/dashboard/templates/${templateId}/edit`,
};

export const eventRoutes = {
  create: '/dashboard/events/new',
  edit: (eventId: string) => `/dashboard/events/${eventId}/edit`,
  detail: (eventId: string) => `/masses/${eventId}`,
  detailWithContext: (
    eventId: string,
    params: Partial<{
      focus: 'slot' | 'discussion' | 'results';
      slotId: string;
      signupId: string;
      messageId: string;
      resultId: string;
    }>,
  ) => {
    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
      if (value) {
        searchParams.set(key, value);
      }
    }

    const query = searchParams.toString();

    return query ? `/masses/${eventId}?${query}` : `/masses/${eventId}`;
  },
  createFromTemplate: (templateId: string) => `/dashboard/events/new?templateId=${templateId}`,
};
